<div class="topbar">
  <h1>Slutopgørelser</h1>
  <div class="topbar__actions">
    @if (slutopgoerelser.length > 0) {
      <small>Viser {{ slutopgoerelser.length }} slutopgørelser</small>
    }
  </div>
</div>
<div class="page__content subscriptions subscriptions--list">
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortData($event)"
    [matSortActive]="sortActiveCol"
    [matSortDirection]="sortDir"
    class="mat-elevation-z0 has-notifications"
    >
    <ng-container matColumnDef="serviceaftale.serviceAbonnement.produkt.id">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let slutopgoerelse">
        <mat-icon
          [svgIcon]="getProductIcon(slutopgoerelse.serviceaftale)"
          [matTooltip]="getProductIcon(slutopgoerelse.serviceaftale) | titlecase"
        ></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="ServiceaftaleState">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let slutopgoerelse">
        <mat-icon
          [matTooltip]="slutopgoerelse.serviceaftale.serviceaftaleState.text"
          [svgIcon]="getStatusIcon(slutopgoerelse.serviceaftale)"
        ></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="kundeNavn">
      <th mat-header-cell *matHeaderCellDef>Navn</th>
      <td mat-cell *matCellDef="let slutopgoerelse">
        {{ slutopgoerelse.serviceaftale.kunde ? slutopgoerelse.serviceaftale.kunde.anlaegsadresse?.name : '' }}
        @if (slutopgoerelse.serviceaftale.kunde?.lokation) {
          <span>({{ slutopgoerelse.serviceaftale.kunde?.lokation }} )</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="serviceaftale.okKundeAftaleNr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Aftalenr</th>
      <td mat-cell *matCellDef="let slutopgoerelse">
        {{ slutopgoerelse.serviceaftale.okKundeAftaleNr }}
      </td>
    </ng-container>
    <ng-container matColumnDef="adresse">
      <th mat-header-cell *matHeaderCellDef>Anlægsadresse</th>
      <td mat-cell *matCellDef="let slutopgoerelse">
        {{ slutopgoerelse.serviceaftale.kunde ? slutopgoerelse.serviceaftale.kunde.anlaegsadresse?.adressLine : '' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="telefon">
      <th mat-header-cell *matHeaderCellDef>Telefonnr.</th>
      <td mat-cell *matCellDef="let slutopgoerelse">
        {{ slutopgoerelse.serviceaftale.kunde ? ($safeNavigationMigration(slutopgoerelse.serviceaftale.kunde.anlaegsadresse?.phone) | dkPhoneNumber) : '' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="Remark">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Bemærkning</th>
      <td mat-cell *matCellDef="let slutopgoerelse">
        {{ slutopgoerelse.remark }}
      </td>
    </ng-container>
    <ng-container matColumnDef="EffectiveDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Effektiv dato</th>
      <td mat-cell *matCellDef="let slutopgoerelse">
        <app-date-user [date]="slutopgoerelse.effectiveDate" [user]="slutopgoerelse.modifiedBy"></app-date-user>
      </td>
    </ng-container>
    <ng-container matColumnDef="CreatedDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Oprettet</th>
      <td mat-cell *matCellDef="let slutopgoerelse">
        <app-date-user [date]="slutopgoerelse.createdDate" [user]="slutopgoerelse.createdBy"></app-date-user>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="onRowClick(row)"
      (dblclick)="onRowDblClick(row.serviceaftale)"
      [class.active]="globalActiveRowID == row.serviceaftale.id"
    ></tr>
  </table>
</div>
@if (quickViewOpen) {
  <div class="quick-view" [@inOutAnimation]>
    <button type="button" class="btn-icon btn-close" (click)="closeQuickView()" title="Luk">
      <mat-icon>close</mat-icon>
    </button>
    <app-quickview [serviceaftale]="selectedaftale"></app-quickview>
    <div class="quick-view__bottom">
      <button mat-raised-button color="primary" [routerLink]="['/aftale', selectedaftale.okKundeAftaleNr]">Åben aftalen</button>
    </div>
  </div>
}
